$(document).ready(function() {
  const announcementBar = $(".announcement-bar");
  const header = $("header");
  let lastScrollTop = 0;
  $(window).scroll(function() {
    const scrollTop = $(this).scrollTop();   
    if (scrollTop > lastScrollTop) {      
     
      header.removeClass("header-scroll-down");
    } else {     
      header.addClass("header-scroll-down");      
    }    
    lastScrollTop = scrollTop;
  });
// NavBar Menu
    $(".nested-navigation").hide();   
  if ($(window).width() > 1023) {
    $(".navigation__item").hover(function() {     
      $(".nested-navigation").hide();     
      var className = $(this).attr("class").split(" ").find(cls => cls.startsWith("subchild-"));           
      var nestedId = "#child-" + className.split("-")[1];     
      $(nestedId).show();
    }, function() {     
    }); 
  }
    $(".header-under-box").hover(function() {      
    }, function() {      
      $(".nested-navigation").hide();
    });
// setTimeout (function(){
//   alert("asas");
//   $(".tempate_landings .product-carousel__item--product").addClass("full_height");
// },2000);

// $(".mobile-navigation .navigation__item.mobile_menuclick").click(function(){
// $(this).find('.mobile_submenu').toggleClass('active');
//   $(this).find('svg').toggleClass('active');
// });



  //  $(document).on("click",".box-radio", function() {
      $('.box-radio').on("click",function() { 
     // debugger;
      if($(this).hasClass('disabled')){
        $(this).parents('.product-info__form').find('button .js-add-to-cart').text("Uitverkocht");   
        $(this).parents('.product-info__form').find('button').prop('disabled', true);
      }
     else{
      var text = $(this).children('input').val();
      var d_price = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('price');
      $(this).parents('.product-info__form').find('button .js-price').text(d_price);
      $(this).parents('.product-info__form').find('button .js-add-to-cart').text("Toevoegen - " + d_price); 
       $(this).parents('.product-info__form').find('button').prop('disabled', false);

       $(this).parents('.product-info__form').find('.prodct_select_variants option').removeAttr('selected','selected');
       $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').attr('selected','selected');

      var perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('price');
      if(text.includes('12')){
         perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('12price');
      } 
      else if(text.includes('6')){
         perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('6price');
      }
      else if(text.includes('24')){
         perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('24price');
      } 
      // else if(text.includes('10')){
      //    perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('10price');
      // }
        else if(text.split(' ').includes('10')) {
    perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('10price');
}
      else if(text.includes('5 stuk')){
         perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('5price');
      }
       else if(text.includes('2 blends')){
         perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('2price');
      }
       else if(text.includes('3 blends')){
         perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('3price');
      }
       else if(text.includes('4 blends')){
         perprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[data-title="'+ text +'"]').data('4price');
      }
       
      $(this).parents('.product-info__form').find('.product_price font:first-child').text(perprice);

      
      if(text.includes('doos')){
          $(this).parents('.product-info__form').find('.product_price font:last-child').text('per stuk');
      }
      else if(text.includes('blend')){
        $(this).parents('.product-info__form').find('.product_price font:last-child').text('per blend');
      }
      else{
          $(this).parents('.product-info__form').find('.product_price font:last-child').text('per stuk');
      }

      // debugger;
      let qty = $(this).parents('.product-info__form').find('.qty_number  input').val();
      let bprice = $(this).parents('.product-info__form').find('.prodct_select_variants option[selected="selected"]')[0].dataset.variantPrice;
       bprice = Shopify.formatMoney(bprice * qty, js.money_format);
      let btntext = $(this).parents('.product-info__form').find('.button .js-add-to-cart').text().split(' - ')[0];
       $(this).parents('.product-info__form').find('.button .js-add-to-cart').text(btntext +' - ' + bprice);
       var varId = $(this).parents('.product-info__form').find('.prodct_select_variants option[selected="selected"]')[0].dataset.variantId;
       $(this).parents('.product-info__form').find('.popup-var-id').val(varId);
     }
    });
});
window.onload = function() {
    $(".header-under-box").show();
};

// 24/11
$(document).ready(function(){
$('.mobile-navigation li.navigation__item svg.icon').on('click' , function(){
 $(this).parents('.mobile-navigation').addClass('is-visible');
 $(this).parents('.mobile-navigation').addClass('active_submenu');
  $(this).parents('.navigation__item').find('.submenu_head').addClass('active');
 $(this).parents('.navigation__item').find('.mobile_submenu').addClass('active');
  $(this).parents('.navigation__item').find('.image_svg').addClass('active');
});

  $('.navigation__item .image_svg , mobile-navigation .submenu_head .nested-navigation__item , .mobile-navigation .navigation .submenu_head').on('click' , function(){
    $(this).parents('.mobile-navigation').removeClass('active_submenu');
    $(this).parents('.mobile-navigation').addClass('is-visible');
      $(this).parents('.navigation__item').find('.submenu_head').removeClass('active');
    $(this).parents('.navigation__item').find('.mobile_submenu').removeClass('active');
     $(this).parents('.navigation__item').find('.image_svg').removeClass('active');
});
});

//01-04
$(document).ready(function(){
          if ($(window).width() <= 1023) {
                    function updateMobileNavigationPosition() {
                      var headerHeight = $('.header').outerHeight(); 
                      var announcementBarHeight = $('#announcement-bar').outerHeight();
                      var totalHeight = headerHeight + announcementBarHeight;
                      $('.mobile-navigation').css('top', totalHeight + 'px');
                  }
                  
                  // Run the function on window load
                  $(window).on('load', updateMobileNavigationPosition);
                  // Run the function on window resize
                  $(window).on('resize', updateMobileNavigationPosition);
          };
});